import { PendingPanel } from './Panel';

/**
 * Event risk is not built yet.
 *
 * The prototype filled this card with earnings dates and macro prints. Those
 * numbers were invented, and a plausible-looking calendar is worse than an empty
 * one: it teaches the reader to trust a date no engine produced. The card names
 * what will go here and stays empty until an engine fills it.
 */
export function EventRiskPanel() {
  return (
    <PendingPanel
      title="Event risk"
      description="Earnings, macro and market-structure dates against the book."
      sprint="Sprint 6"
      detail={
        <>
          Not built. This will hold dated exposures — earnings inside the horizon, macro prints, index rebalances and
          option expiries — weighted by how much of the book sits on each date. Nothing is shown until an engine
          computes it; a calendar of plausible-looking dates would read as measured and is not.
        </>
      }
    />
  );
}
